import commonAuthRouter from "@/router/common-auth-router";

const router = {
    path: '/wms',
    name: 'wms',
    component: () => import('@/views/wms/Index.vue'),
    redirect: '/wms/auth',
    children: [
        {
            path: 'auth',
            name: 'auth',
            component: () => import('@/views/wms/Auth.vue'),
            redirect: '/wms/auth/login',
            children: commonAuthRouter
        },
        {
            path: 'home',
            name: 'home',
            component: () => import('@/views/wms/Home.vue'),
            redirect: '/wms/home/realtime-order',
            children: [
                {
                    path: 'overview',
                    name: 'overview',
                    component: () => import('@/views/wms/pages/DataOverview.vue'),
                },
                {
                    path: 'cell-stock-analysis',
                    name: 'cell-stock-analysis',
                    component: () => import('@/views/wms/pages/CellStockAnalysis.vue')
                },
                {
                    path: 'warehouse',
                    name: 'warehouse',
                    component: () => import('@/views/wms/pages/Warehouse.vue')
                },
                {
                    path: 'rack/:id',
                    name: 'rack',
                    component: () => import('@/views/wms/pages/Rack.vue')
                },
                {
                    path: 'supplement',
                    name: 'supplement',
                    component: () => import('@/views/wms/pages/Supplement.vue')
                },
                {
                    path: 'supplies',
                    name: 'supplies',
                    component: () => import('@/views/wms/pages/Supplies.vue')
                },
                {
                    path: 'supplies-out-in',
                    name: 'supplies-out-in',
                    component: () => import('@/views/wms/pages/SuppliesOutIn.vue')
                },
                {
                    path: 'purchase-list',
                    name: 'purchase-list',
                    component: () => import('@/views/wms/pages/PurchaseList.vue')
                },
                {
                    path: 'purchase-sku-list',
                    name: 'purchase-sku-list',
                    component: () => import('@/views/wms/pages/PurchaseSkuList.vue')
                },
                {
                    path: 'wms-purchase-list',
                    name: 'wms-purchase-list',
                    component: () => import('@/views/wms/pages/WmsPurchaseInList.vue')
                },
                {
                    path: 'dead-stock-sku',
                    name: 'dead-stock-sku',
                    component: () => import('@/views/wms/pages/DeadStockSku.vue')
                },
                {
                    path: 'wms-purchase-setting',
                    name: 'wms-purchase-setting',
                    component: () => import('@/views/wms/pages/WmsPurchaseSetting.vue')
                },
                {
                    path: 'wms-purchase-sku-list',
                    name: 'wms-purchase-sku-list',
                    component: () => import('@/views/wms/pages/WmsPurchaseList.vue')
                },
                {
                    path: 'supplier',
                    name: 'supplier',
                    component: () => import('@/views/wms/pages/Supplier.vue')
                },
                {
                    path: 'sku',
                    name: 'sku',
                    component: () => import('@/views/wms/pages/Sku.vue')
                },
                {
                    path: 'store-sku',
                    name: 'store-sku',
                    component: () => import('@/views/wms/pages/SkuStore.vue')
                },
                {
                    path: 'sku-stock-bind',
                    name: 'sku-stock-bind',
                    component: () => import('@/views/wms/pages/SkuStockBind.vue')
                },
                {
                    path: 'sku-bind',
                    name: 'sku-bind',
                    component: () => import('@/views/wms/pages/SkuBind.vue')
                },
                {
                    path: 'sku-sale',
                    name: 'sku-sale',
                    component: () => import('@/views/wms/pages/SkuSale.vue'),
                },
                {
                    path: 'sku-sale-info-analysis',
                    name: 'sku-sale-info-analysis',
                    component: () => import('@/views/wms/pages/SkuSaleInfoAnalysis.vue'),
                },
                {
                    path: 'sku-profit',
                    name: 'sku-profit',
                    component: () => import('@/views/wms/pages/SkuProfit.vue')
                },
                {
                    path: 'sku-stock-flow',
                    name: 'sku-stock-flow',
                    component: () => import('@/views/wms/pages/SkuStockFlow.vue'),
                },
                {
                    path: 'sku-desc',
                    name: 'sku-desc',
                    component: () => import('@/views/wms/pages/SkuDesc.vue')
                },
                {
                    path: 'realtime-order',
                    name: 'realtime-order',
                    component: () => import('@/views/wms/pages/OrderRealtime.vue')
                },
                {
                    path: 'all-order',
                    name: 'all-order',
                    component: () => import('@/views/wms/pages/OrderHistory.vue')
                },
                {
                    path: 'background-task',
                    name: 'background-task',
                    component: () => import('@/views/wms/pages/BackgroundTask.vue')
                },
                {
                    path: 'mwms-purchase-analysis',
                    name: 'mwms-purchase-analysis',
                    component: () => import('@/views/wms/pages/WmsPurchaseAnalysis.vue')
                },
                {
                    path: 'mwms-purchase-list',
                    name: 'mwms-purchase-list',
                    component: () => import('@/views/wms/pages/WmsPurchaseList.vue')
                }
                , {
                    path: 'mwms-purchase-in-list',
                    name: 'mwms-purchase-in-list',
                    component: () => import('@/views/wms/pages/WmsPurchaseInList.vue')
                }, {
                    path: 'mwms-sku-value',
                    name: 'mwms-sku-value',
                    component: () => import('@/views/wms/pages/SkuValue.vue')
                }
                , {
                    path: 'sku-play-voice',
                    name: 'sku-play-voice',
                    component: () => import('@/views/wms/pages/SkuPlayVoice.vue')
                }

            ]
        },
        {
            path: 'print',
            name: 'print',
            component: () => import('@/views/wms/Print.vue'),
            children: [
                {
                    path: 'supplies-print-mode/:warehouse/:sNo/:status',
                    name: 'supplies-print-mode',
                    component: () => import('@/views/wms/pages/SuppliesPrintMode.vue'),
                }
            ]
        },
        {
            path: 'shop-checkout/:warehouse',
            name: 'shop-checkout',
            component: () => import('@/views/wms/ShopCheckout.vue'),
        }
    ]

}
export default router